import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'execute-workflow-action',
  name: 'Execute Workflow',
  category: 'flow-control',
  description: 'Execute another workflow and pass data between workflows',
  icon: 'Workflow',
  color: 'amber',
  version: '1.0.0',
  
  defaults: {
    name: 'Execute Workflow',
    color: '#f59e0b'
  },
  
  subtitle: '={{ $parameter.workflowId ? "Workflow: " + $parameter.workflowId : "Configure workflow" }}',
  
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  tags: ['workflow', 'execute', 'subworkflow', 'nested', 'call', 'parent'],
  
  comingSoon: false,
  
  metadata: {
    documentation: 'Execute another workflow as a sub-workflow and pass data between parent and child workflows'
  }
};

export default definition;
